// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_layout {
    display: flex;
    flex-direction: row;
    gap: 16px;
}

.home_layout_left {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.home_layout_left > hr {
    border: none;
    border-top: 1px solid var(--border-light);
    margin: 0;
}

.home_layout_right {
    display: none;
}

.home_title {
    font-size: 16px;
    font-weight: 600;
    color: var(--text-primary);
}

.home_flex_children {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: start;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/home.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,yCAAyC;IACzC,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB","sourcesContent":[".home_layout {\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n}\n\n.home_layout_left {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n}\n\n.home_layout_left > hr {\n    border: none;\n    border-top: 1px solid var(--border-light);\n    margin: 0;\n}\n\n.home_layout_right {\n    display: none;\n}\n\n.home_title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.home_flex_children {\n    display: flex;\n    flex-direction: row;\n    gap: 12px;\n    align-items: start;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
